var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBergurMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    width: 20,
    height: 20,
    transform: "translate(307 21)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_27",
    "data-name": "Mask Group 27",
    transform: "translate(-307 -21)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(305 19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M21.333,19.333H2.667a.667.667,0,1,1,0-1.333H21.333a.667.667,0,1,1,0,1.333Z",
    fill: "var(--secondary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M21.333,12.667H2.667a.667.667,0,1,1,0-1.333H21.333a.667.667,0,0,1,0,1.333Z",
    fill: "var(--secondary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M21.333,6H2.667a.667.667,0,1,1,0-1.333H21.333a.667.667,0,0,1,0,1.333Z",
    fill: "var(--secondary-color)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBergurMenu);
export default __webpack_public_path__ + "static/media/bergur-menu.783ba0b65bce28be2a90209705c9cada.svg";
export { ForwardRef as ReactComponent };